// Lib
import React from 'react';
import { useSelector } from 'react-redux';

// Components
import StickyButtons from '../../../components/Button/StickyButtons';

// Pages
import Materials from '../../Materials';

// Hooks
import useRecurringMaterials from '../hooks/useRecurringMaterials';

const RecurringMaterials = () => {
  const { onCancel, onSave, loading } = useRecurringMaterials();
  const isSearchActive = useSelector((state) => state.isSearchActive);

  return (
    <Materials onlyContent>
      {!isSearchActive && (
        <StickyButtons
          onReject={onCancel}
          onAccept={onSave}
          loading={loading}
        />
      )}
    </Materials>
  );
};

export default RecurringMaterials;
